import React, {Component} from "react";
import CanvasDraw from "react-canvas-draw";
import GeneralHeader from "components/Headers/GeneralHeader";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Input,
    Container,
    Row,
    Col,
    Label,Modal
} from "reactstrap";
import axios from 'axios';
import Loader from 'react-loader-spinner';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class MarkedScriptEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            color: "#FF0000",
            width: 800,
            height: 1020,
            brushRadius: 0.8,
            lazyRadius: 1,
            upload_id: this.props.match.params.upload_id,
            images: [],
            imagesLoading: true,
            currentPage: this.props.match.params.page_number,
            currentImagePos: 0,
            student: {},
            annotation: '',
            student_id: '',
            submission_total:0,
            submission_mark:0,
            modalIsOpen: false,
            marked:false,
        };
        this.getScriptImages = this.getScriptImages.bind(this);
        this.goToNext = this.goToNext.bind(this);
        this.saveAnnotation = this.saveAnnotation.bind(this);
        this.saveTempScripts = this.saveTempScripts.bind(this);
        this.getTempScripts = this.getTempScripts.bind(this);
        this.goToPrevious = this.goToPrevious.bind(this);
        this.saveScripts = this.saveScripts.bind(this);
        this.checkScripts = this.checkScripts.bind(this);
        this.saveAsessmentResult = this.saveAsessmentResult.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.showpreViewDialog = this.showpreViewDialog.bind(this);
        this.getAssessmentTotal = this.getAssessmentTotal.bind(this);
        this.editScript = this.editScript.bind(this);

    }
    componentDidMount() { // let's change the color randomly every 2 seconds. fun!
        // //console.log('Check Scriptview state', this.state);
        // if (this.props.match.params.page_number == "1") {
            
        // } else if (this.props.match.params.page_number > 1) {
        //     this.getTempScripts();
        // }
       
        this.checkScripts();
        this.getAssessmentTotal();
    }

    checkScripts() {
        let token = localStorage.getItem('access_token');
        // //console.log('getting temporal scripts');
        let cur = this;
        axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/check-scripts/' + cur.props.match.params.upload_id + '/' + cur.props.match.params.page_number, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            console.log('is script available', res.data);
            if (res.data.available == true) {
                console.log('is script availableinner', res.data);
                // this.setState({marked:true});
                cur.getTempScripts();
            } else {
                cur.getScriptImages();
            }
            return res.data.available;
        }).catch(error => {
            //console.log('error', error);
        });
    }

    saveAsessmentResult(){
      let cur = this;
      const data = {
        submission_total: cur.state.submission_total,
        submission_mark: cur.state.submission_mark,
        submission_id: cur.state.upload_id, 
        result_type: 'annotated'      
    };

    if( cur.state.submission_total>0){
        axios({
            headers: {
                'content-type': 'application/json'
            },
            method: 'post',
            url: 'https://admin.thinkdigitalacademy.org/api/submit-marker-result',
            data: data
        }).then(res => {
           
            toast(res.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: toast.TYPE.SUCCESS
          });
        }).catch(error => {
            let error_result = error.response;
            toast(error_result.data.error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
        });
    }else{
        toast("Please enter a valid total. Total mark can not be less than or equal to zero", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: toast.TYPE.ERROR
        });
    }

    
    }

    handleChange(event){
      const target = event.target;
      const value =  target.value;
      const name = target.name;
      let cur = this.state;
    console.log('on change hit',name);
    console.log('on change hit',cur.submission_total);
      if(name=='submission_mark'){
          if(value>Number(cur.submission_total)){
              console.log('hit');
            toast('Total obtained can not be greater than the assessment total!!', {
                position: "top-right",
                autoClose: 5000,    
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
          }else{
            this.setState({
                [name]: value
              });
          }
      }else{
        this.setState({
            [name]: value
          });
      }
    }

    goToNext() {
        let current_image_pos = this.state.currentImagePos + 1;
        let current_page = Number(this.state.currentPage) + 1;
        // //console.log('clicked go to next', current_page);
        this.state.currentImagePos = current_image_pos;
        this.state.currentPage = current_page;
        this.setState({currentImagePos: current_image_pos, currentPage: current_page});
        // //console.log("checking script state", this.state.images[this.state.currentImagePos]);
        window.location.href = '/admin/mark_script/' + this.state.upload_id + '/' + this.state.currentPage;
    }

    goToPrevious() {
        let current_image_pos = Number(this.state.currentImagePos) - 1;
        let current_page = Number(this.state.currentPage) - 1;
        // //console.log('clicked go to next', current_page);
        this.state.currentImagePos = current_image_pos;
        this.state.currentPage = current_page;

        this.setState({currentImagePos: current_image_pos, currentPage: current_page});
        // //console.log("checking script state", this.state.images[this.state.currentImagePos]);
        window.location.href = '/admin/mark_script/' + this.state.upload_id + '/' + this.state.currentPage;
    }

    getTempScripts() {
        let token = localStorage.getItem('access_token');
        //console.log('getting temporal scripts');
        let cur = this;
        axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/get-temp-scripts/' + cur.props.match.params.upload_id + '/' + cur.props.match.params.page_number, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            // console.log('current scripts', ));
            let annotations_object = JSON.parse(res.data.annotation);
                let marked = false;
                if(annotations_object.lines.length>0){
                    marked = true;
                }
            this.setState({marked:marked,images: res.data.images, student_id: res.data.student_id, imagesLoading: false, annotation: res.data.annotation});
            cur.loadableCanvas.loadSaveData(res.data.annotation);
        }).catch(error => {
            // //console.log('error', error);
        });
    }

    getAssessmentTotal(){
        let token = localStorage.getItem('access_token');
        //console.log('getting temporal scripts');
        let cur = this;
        axios.get('https://admin.thinkdigitalacademy.org/api/get-assessment-total/' + cur.props.match.params.upload_id, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            // console.log('assessment', res.data);
            this.setState({assessment: res.data.assessment,submission_total:res.data.assessment.total});
        }).catch(error => {
            // //console.log('error', error);
        });
    }

    saveTempScripts() {
        let cur = this;
        this.state.images.forEach(function (obj) {
            //console.log('check props', cur);
            //console.log('check image_url', obj);
            const data = {
                annotation: '',
                upload_id: cur.state.upload_id,
                student_id: cur.state.student.id,
                picture_url: obj,
                page_number: cur.state.currentPage
            };

            axios({
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + localStorage.getItem('access_token')
                },
                method: 'post',
                url: 'https://markerportalbackend.thinkdigitalacademy.org/api/save-temp-script',
                data: data
            }).then(res => {
                // //console.log(res);
                // //console.log(res.data);
                // //console.log('save temp scripted', res.data);

            }).catch(error => {
                let error_result = error.response;
                toast(error_result.data.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    type: toast.TYPE.ERROR
                });
            });
        })

    }

    saveScripts() {
        let cur = this;
        this.state.images.forEach(function (obj, index) {
            const data = {
                annotation: cur.saveableCanvas.getSaveData(),
                upload_id: cur.props.match.params.upload_id,
                student_id: cur.state.student.id,
                page_number: index + 1,
                picture_url: obj
            };

            axios({
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + localStorage.getItem('access_token')
                },
                method: 'post',
                url: 'https://markerportalbackend.thinkdigitalacademy.org/api/save-annotated-script',
                data: data
            }).then(res => {
                // //console.log(res);
                // //console.log(res.data);
                // //console.log('save annotaion', res.data);

            }).catch(error => {
                let error_result = error.response;
                toast(error_result.data.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    type: toast.TYPE.ERROR
                });
            });
        });
    }

    saveAnnotation() {
        const data = {
            annotation: this.saveableCanvas.getSaveData(),
            upload_id: this.props.match.params.upload_id,
            student_id: this.state.student_id,
            page_number: this.props.match.params.page_number,
            picture_url: this.state.images[this.state.currentPage - 1]
        };

        let cur = this;

        axios({
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            method: 'post',
            url: 'https://markerportalbackend.thinkdigitalacademy.org/api/update-annotated-script',
            data: data
        }).then(res => {
            // //console.log(res);
            // //console.log(res.data);
            // //console.log('save annotaion', res.data);
            cur.setState({annotation: res.data.script.annotation});
            cur.loadableCanvas.loadSaveData(cur.state.annotation);
            toast(res.data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.SUCCESS
            });

        }).catch(error => {
            let error_result = error.response;
            //console.log(error_result);
            toast('Error occurred. ' + error_result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
        });
    }

    getScriptImages() {
        // //console.log('getting script images');
        axios.get('https://admin.thinkdigitalacademy.org/api/get-ass-to-mark/' + this.state.upload_id).then(res => {
            //console.log('images', res.data);
            this.setState({images: res.data.images, student: res.data.student, imagesLoading: false});
            if(res.data.images.length>0){
                this.saveScripts();
            }else{
                toast('No Script found for this upload, please check if the file was actually uploaded', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    type: toast.TYPE.ERROR
                });
            }
            
            // this.state.images = res.data.images;
        }).catch(error => {
            // //console.log('errorxzzx show toast', error);
            toast('Error occurred', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
            this.setState({imagesLoading: false, images: []});
        });
    }

    
    toggle() {
        this.setState({
            modalIsOpen: !this.state.modalIsOpen
        });
    }

    showpreViewDialog(){
        this.setState({modalIsOpen:true});
    }

    editScript(){
        this.setState({marked:false});
    }
    render() {
        return (
            <div>
                <ToastContainer position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover/>
                <ToastContainer/>
                <GeneralHeader/>
                <Container className="mt--7" fluid>
                    <Row>
                        <Col className="order-xl-1" xl="12">
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row>
                                        <Col md={1}>
                                            <Button onClick={
                                                    this.saveAnnotation
                                                }
                                                size="sm"
                                                color="success"
                                                type="button">
                                                Save
                                            </Button>
                                        </Col>
                                        <Col md={1}>
                                            <Button size="sm" color="danger" type="button"
                                                onClick={
                                                    () => {
                                                        this.saveableCanvas.clear();
                                                        this.saveAnnotation();
                                                    }
                                            }>
                                                Clear
                                            </Button>
                                        </Col>
                                        <Col md={1}>
                                            <Button size="sm" color="warning" type="button"
                                                onClick={
                                                    () => {
                                                        this.saveableCanvas.undo();
                                                    }
                                            }>
                                                Undo
                                            </Button>
                                        </Col>
                                        {
                                            this.state.marked && <Col md={1}><Button size="sm" color="info" type="button"
                                            onClick={
                                                this.editScript
                                        }>
                                            Start Edit
                                        </Button></Col>
                                        }

                                        </Row>
                                    
                                </CardHeader>
                                <CardBody>
                                    {
                                        !this.state.marked?
                                        <div>
                                            {
                                    this.state.imagesLoading ? <Loader type="Puff" color="#00BFFF"
                                        height={100}
                                        width={100}
                                        timeout={5000}
                                        //3 secs
                                    /> : <div>
                                        <Row>
                                            <Col md={12}>
                                                <header>Marking Pad</header>
                                                <CanvasDraw ref={
                                                        canvasDraw => (this.saveableCanvas = canvasDraw)
                                                    }
                                                    brushColor={
                                                        this.state.color
                                                    }
                                                    brushRadius={
                                                        this.state.brushRadius
                                                    }
                                                    lazyRadius={
                                                        this.state.lazyRadius
                                                    }
                                                    canvasWidth={
                                                        0.75*this.state.width
                                                    }
                                                    canvasHeight={
                                                        0.75*this.state.height
                                                    }
                                                    loadTimeOffset={0}
                                                    imgSrc={
                                                        `https://admin.thinkdigitalacademy.org/` + this.state.images[this.state.currentPage - 1]
                                                    }/>
                                                </Col>
                                            
                                        </Row>
                                        <Row>
                                        <header>Preview Tab (Ignore)</header>
                                        <CanvasDraw hidden disabled hideGrid
                                                    canvasWidth={
                                                        0.75*this.state.width
                                                    }
                                                    canvasHeight={
                                                        0.75*this.state.height
                                                    }
                                                    imgSrc={
                                                        `https://admin.thinkdigitalacademy.org/` + this.state.images[this.state.currentPage - 1]
                                                    }
                                                    ref={
                                                        canvasDraw => (this.loadableCanvas = canvasDraw)
                                                    }/>
                                        </Row>
                                    </div>
                                }
                                        </div>:
                                        <div>{
                                            this.state.imagesLoading ? <Loader type="Puff" color="#00BFFF"
                                        height={100}
                                        width={100}
                                        timeout={5000}
                                        //3 secs
                                    /> : <div>
                                     <Row>
                                        <Col md={12}>
                                                <header>Marked Script Preview</header>
                                                <CanvasDraw disabled hideGrid
                                                    canvasWidth={
                                                        0.75*this.state.width
                                                    }
                                                    canvasHeight={
                                                        0.75*this.state.height
                                                    }
                                                    imgSrc={
                                                        `https://admin.thinkdigitalacademy.org/` + this.state.images[this.state.currentPage - 1]
                                                    }
                                                    ref={
                                                        canvasDraw => (this.loadableCanvas = canvasDraw)
                                                    }/>
                                                    <br/>
                                                    {/* <Button size="sm" color="info" type="button"
                                                onClick={
                                                    this.showpreViewDialog
                                            }>
                                                View Full Preview
                                            </Button> */}
                                                    </Col>
                                        </Row>
                                        </div>
                                            }
                                            
                                        </div>
                                    }
                                      </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal className="modal-dialog-centered"
                            isOpen={
                                this.state.modalIsOpen
                            }
                            toggle={
                                this.toggle
                            }
                            size='lg'>
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Marked Script Preview
                                </h5>
                                <button aria-label="Close" className="close" data-dismiss="modal" type="button"
                                    onClick={
                                        this.toggle
                                }>
                                    <span aria-hidden={true}>×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                            <Row>
                                <Col lg={12}>
                            <CanvasDraw disabled hideGrid
                                                    canvasWidth={
                                                        this.state.width
                                                    }
                                                    canvasHeight={
                                                        this.state.height
                                                    }
                                                    imgSrc={
                                                        `https://admin.thinkdigitalacademy.org/` + this.state.images[this.state.currentPage - 1]
                                                    }
                                                    ref={
                                                        canvasDraw => (this.loadableCanvas = canvasDraw)
                                                    }/></Col>
                                      </Row>

                            </div>
                            <div className="modal-footer">                               
                               
                            </div>
                        </Modal>
                </Container>

            </div>
        );
    }
};
export default MarkedScriptEdit;
